export default __webpack_public_path__ + "3c8023d6cc1c83509789fc561a9943d4.ico";